import "./utils/counter";

jQuery(document).ready(function ($) {
  // Hamburger menu & Menu mobile
  const $window = $(window);
  const $html = $("html");
  const $body = $("body");
  const $mobileMenu = $(".wrapper-menu-mobile");
  const $menuToggle = $(".navbar-toggler");
  let mobileMenuScrollTop = 0;
  const desktopMenuBreakpoint = 992;

  const lockMobileMenuScroll = () => {
    mobileMenuScrollTop = $window.scrollTop();
    $body.css({
      position: "fixed",
      top: `-${mobileMenuScrollTop}px`,
      left: "0",
      right: "0",
      width: "100%",
      overflow: "hidden",
    });
    $html.css("overflow", "hidden");
  };

  const unlockMobileMenuScroll = () => {
    const scrollTop = mobileMenuScrollTop;
    const previousHtmlScrollBehavior = document.documentElement.style.scrollBehavior;
    const previousBodyScrollBehavior = document.body.style.scrollBehavior;

    document.documentElement.style.scrollBehavior = "auto";
    document.body.style.scrollBehavior = "auto";

    $body.css({
      position: "",
      top: "",
      left: "",
      right: "",
      width: "",
      overflow: "",
    });
    $html.css("overflow", "");
    window.scrollTo(0, scrollTop);

    window.requestAnimationFrame(() => {
      document.documentElement.style.scrollBehavior = previousHtmlScrollBehavior;
      document.body.style.scrollBehavior = previousBodyScrollBehavior;
    });
  };

  const openMobileMenu = () => {
    $mobileMenu.addClass("show").css({
      overflowY: "auto",
      WebkitOverflowScrolling: "touch",
    });
    $menuToggle.addClass("is-toggled");
    lockMobileMenuScroll();
  };

  const closeMobileMenu = () => {
    $mobileMenu.removeClass("show").css({
      overflowY: "",
      WebkitOverflowScrolling: "",
    });
    $menuToggle.removeClass("is-toggled");
    unlockMobileMenuScroll();
  };

  $menuToggle.on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    if ($mobileMenu.hasClass("show")) {
      closeMobileMenu();
      return;
    }

    openMobileMenu();
  });

  $window.on("resize", function () {
    if ($window.width() > desktopMenuBreakpoint && $mobileMenu.hasClass("show")) {
      closeMobileMenu();
    }
  });
  // Dropdown menu
  $(".menu-item--expanded").click(function (e) {
    $(".menu-item--expanded")
      .not(this)
      .children()
      .removeClass("submenu-active");
    $(this).children().toggleClass("submenu-active");
  });
  $(document).on("click", function (e) {
    if ($(e.target).closest(".menu-item--expanded > *").length === 0) {
      $(".menu-item--expanded > .sub-menu").removeClass("submenu-active");
      $(".menu-item--expanded > .nav-link").removeClass("submenu-active");
    }
  });
  // Accordion
  $(".accordion__wrapper__title").on("click", function () {
    $(this).children(".accordion__icon").toggleClass("open");
  });
  const accordionBtns = document.querySelectorAll(".accordion__wrapper__title");
  accordionBtns.forEach((accordion) => {
    accordion.onclick = function () {
      this.classList.toggle("is-open");
      let content = this.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    };
  });

  // Apri l'accordion TOC di default e correggi altezza
  const tocAccordion = document.querySelector(
    ".toc .accordion__wrapper__title"
  );
  if (tocAccordion) {
    tocAccordion.classList.add("is-open");
    const tocIcon = tocAccordion.querySelector(".accordion__icon");
    if (tocIcon) {
      tocIcon.classList.add("open");
    }
    let content = tocAccordion.nextElementSibling;
    if (content) {
      // Correggi altezza dopo che la TOC è stata popolata
      const adjustHeight = () => {
        content.style.maxHeight = content.scrollHeight + "px";
      };
      // Esegui l'aggiustamento dopo la generazione dinamica della TOC
      setTimeout(adjustHeight, 100);
    }
  }

  // Generazione dinamica della TOC
  const tocList = document.querySelector(
    ".toc.auto .field--name-field-toc-text ul"
  );
  const articleHeadings = document.querySelectorAll(
    "article h2:not(.hero__page__wrapper h2)"
  );
  if (tocList && articleHeadings.length > 0) {
    articleHeadings.forEach((heading, index) => {
      // Genera un ID unico per ogni h2
      const textContent = heading.textContent.trim();
      const id = `${index}-${textContent.replace(/\s+/g, "-").toLowerCase()}`;
      heading.setAttribute("id", id);

      // Crea un elemento <li> con un link all'h2
      const listItem = document.createElement("li");
      const anchor = document.createElement("a");
      anchor.href = `#${id}`;
      anchor.textContent = textContent;

      // Aggiungi il link all'elemento <li> e aggiungilo alla TOC
      listItem.appendChild(anchor);
      tocList.appendChild(listItem);
    });
  }

  // swiper
  var cs2Swiper = new Swiper(".swiper-container", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 30,
    scrollbar: {
      el: ".swiper-scrollbar",
    },
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });


  // swiper news
  var cs2Swiper = new Swiper(".swiper-news", {
    loop: false,
    slidesPerView: 3,
    spaceBetween: 24,
    autoplay: {
      delay: 5000,
    },
     breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 12,
      },
      568: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 24,
      }
    }
  });
  // swiper news
  var cs2Swiper = new Swiper(".swiper-news-latest", {
    loop: false,
    slidesPerView: 3,
    spaceBetween: 24,
    navigation: {
      nextEl: '.wrapper-btns-swiper > .swiper-buttons > .swiper-button-next',
      prevEl: '.wrapper-btns-swiper > .swiper-buttons > .swiper-button-prev',
    },
    pagination: {
      el: '.wrapper-btns-swiper > .swiper-pagination',
      type: 'bullets',
    },
    autoplay: {
      delay: 5000,
    },
     breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 12,
      },
      568: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 24,
      }
    }
  });

  // swiper events
  var cs2Swiper = new Swiper(".swiper-events", {
    loop: false,
    slidesPerView: 3,
    spaceBetween: 24,
    autoplay: {
      delay: 4000,
    }, 
     breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 12,
      },
      668: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 24,
      }
    }
  });

  // swiper ct slider (contenuti in evidenza): nav per singola istanza
  document.querySelectorAll(".section__ct-slider").forEach(function (slider) {
    new Swiper(slider.querySelector(".swiper-ct-slider"), {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 48,
      autoHeight: true,
      navigation: {
        nextEl: slider.querySelector(".swiper-button-next"),
        prevEl: slider.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        type: "bullets",
        clickable: true,
      },
    });
  });

  // swiper reviews: 3 card su desktop, nav per singola istanza
  document.querySelectorAll(".section__reviews").forEach(function (reviews) {
    new Swiper(reviews.querySelector(".swiper-reviews"), {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: reviews.querySelector(".swiper-button-next"),
        prevEl: reviews.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: reviews.querySelector(".swiper-pagination"),
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        668: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    });
  });

  // conventions list: "Mostra di più" solo se il testo supera le 3 righe
  document.querySelectorAll(".js-convention").forEach(function (item) {
    var text = item.querySelector(".js-convention-text");
    var toggle = item.querySelector(".js-convention-toggle");

    if (!text || !toggle || text.scrollHeight <= text.clientHeight + 1) {
      return;
    }

    toggle.hidden = false;
    toggle.addEventListener("click", function () {
      var open = item.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });

  document.addEventListener(
    "wpcf7mailsent",
    function (event) {
      setTimeout(() => {
        location = "/grazie/";
      }, 1000);
    },
    false
  );

  // GSAP fade-up
  if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    gsap.registerPlugin(ScrollTrigger, SplitText);

    document.querySelectorAll(".js-gsap-fadeup").forEach((el) => {
      gsap.from(el, {
        autoAlpha: 0,
        y: 40,
        duration: 0.8,
        ease: "power2.out",
        scrollTrigger: {
          trigger: el,
          start: "top 90%",
          once: true,
        },
      });
    });

    document.querySelectorAll("h1, h2").forEach((heading) => {
      // niente testo che si accende allo scroll nella pagina di ricerca (titoli dei risultati)
      if (!heading.textContent.trim() || heading.closest(".search_page")) {
        return;
      }

      const hasInteractiveContent = heading.querySelector("a, button, input, select, textarea");
      const { words } = SplitText.create(heading, {
        type: "words",
        aria: hasInteractiveContent ? "none" : "auto",
      });
      const isHeroHeading = heading.closest(".hero__page__wrapper, .single-post .col-left__heading");

      const animation = {
        opacity: 1,
        duration: isHeroHeading ? 0.7 : 0.5,
        stagger: isHeroHeading ? 0.1 : 0.2,
        ease: isHeroHeading ? "power1.out" : "none",
      };

      if (!isHeroHeading) {
        animation.scrollTrigger = {
          trigger: heading,
          start: "clamp(top 90%)",
          end: "clamp(center center)",
          scrub: true,
        };
      }

      gsap.fromTo(words, { opacity: 0.25 }, animation);
    });

    const imageSelectors = [
      ".hero__page__wrapper .hero__page__media img",
      ".section__media__wrapper img",
      ".section__text-media__wrapper .column-media-wrap__media img",
      ".section__tt__wrapper .column-tt-col img",
      ".section__gallery__wrapper .swiper-slide img",
      ".news-card__image img",
      ".event-card__image img",
      ".section__people-list__photo",
      ".single-post .col-left__content img",
    ];

    document.querySelectorAll(imageSelectors.join(", ")).forEach((image) => {
      const mask = image.closest(".news-card__image, .event-card__image, .column-media-wrap__media")
        || image.closest("picture")
        || image;
      const isHeroImage = Boolean(image.closest(".hero__page__wrapper"));
      // negli slider il trigger è lo slider intero: le slide fuori schermo in orizzontale
      // non devono avere un trigger proprio, si rivelano insieme quando lo slider entra in vista
      const slider = image.closest(".swiper");
      const slideIndex = slider ? [...slider.querySelectorAll(".swiper-slide")].indexOf(image.closest(".swiper-slide")) : 0;

      if (mask.tagName === "PICTURE") {
        gsap.set(mask, { display: "block" });
      }
      gsap.set(mask, { clipPath: "inset(0% 0% 100% 0%)" });
      gsap.set(image, { scale: 1.3, transformOrigin: "center center" });

      const reveal = () => {
        const timelineOptions = {
          defaults: { duration: 1.15, ease: "power3.out" },
          // slide successive leggermente sfalsate (solo le prime, le altre partono subito)
          delay: slider ? Math.min(slideIndex, 3) * 0.12 : 0,
        };

        if (!isHeroImage) {
          // parte quando il bordo superiore entra nell'85% della viewport.
          // Niente clamp(): con lo start portato a 0 ciò che è già visibile al caricamento
          // restava nascosto finché non si scrollava; senza clamp si rivela subito
          timelineOptions.scrollTrigger = {
            trigger: slider || mask,
            start: "top 85%",
            once: true,
          };
        }

        gsap.timeline(timelineOptions)
          .to(mask, {
            clipPath: "inset(0% 0% 0% 0%)",
            onComplete: () => gsap.set(mask, { clearProps: "clipPath" }),
          }, 0)
          .to(image, {
            scale: 1,
            onComplete: () => gsap.set(image, { clearProps: "transform" }),
          }, 0);
      };

      if (image.complete && image.naturalWidth) {
        reveal();
      } else if (!image.complete) {
        // il clip-path rende l'immagine "non visibile": il lazy-load del browser non partirebbe mai
        if (image.loading === "lazy") {
          ScrollTrigger.create({
            trigger: slider || mask,
            start: "top bottom+=600",
            once: true,
            onEnter: () => {
              image.loading = "eager";
            },
          });
        }
        image.addEventListener("load", reveal, { once: true });
        image.addEventListener("error", () => {
          gsap.set(mask, { clearProps: "clipPath" });
          gsap.set(image, { clearProps: "transform" });
        }, { once: true });
      } else {
        gsap.set(mask, { clearProps: "clipPath" });
        gsap.set(image, { clearProps: "transform" });
      }
    });

    ScrollTrigger.refresh();
    // font, immagini e slider cambiano il layout dopo l'init: ricalcola le posizioni dei trigger
    window.addEventListener("load", () => ScrollTrigger.refresh(), { once: true });
  }
});
